<template>
  <div
    class="AtlasAlert"
    :class="{
      'AtlasAlert--snackbar': isSnackbar,
      [`AtlasAlert--${type}`]: type,
    }"
    role="alert"
  >
    <atlas-icon :name="icon" class="AtlasAlert-icon" :size="null" />

    <h3 class="AtlasAlert-header">An error occurred.</h3>
    <p class="AtlasAlert-message">{{ text }}</p>

    <div
      class="AtlasAlert-dismiss"
      v-if="isSnackbar"
      @click="$emit('dismiss')"
      title="Dismiss"
    >
      <atlas-icon class="AtlasAlert-dismissIcon" name="close" :size="22" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'atlas-alert',

  props: {
    message: {
      type: String,
    },

    status: {
      type: Number,
    },

    isSnackbar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    type() {
      return this.status >= 500 ? 'server' : 'client';
    },

    icon() {
      return { client: 'warning', server: 'error' }[this.type];
    },

    text() {
      return [this.status, this.message].filter((x) => x).join(': ');
    },
  },
};
</script>

<style lang="scss">
.AtlasAlert {
  @include elevation;
  width: 100%;
  max-width: 300px;
  padding: $gutter;
  margin: 0 auto;
  background-color: color(warning);
  border-radius: 3px;

  &--server {
    @include antialias;
    background-color: color(error);
    color: color(white);
  }

  &--snackbar {
    @include position(fixed, 0 null null 50%);
    @include border-top-radius(0);
    @include padding(5px 36px 5px null);
    z-index: z(alert);
    font-size: 0.9em;
    transform: translateX(-50%);
  }

  &-icon {
    @include size(40px);
    display: block;
    margin: 0.3em $gutter 0 0;
    float: left;
  }

  &-header {
    margin: 0;
    line-height: 1.6;
  }

  &-message {
    padding-bottom: 0.4em;
    margin: 0;
  }

  &-dismiss {
    @include position(absolute, 0 0 0 null);
    width: 36px;
    padding: 0 7px;
    cursor: pointer;
  }

  &-dismissIcon {
    @include position(absolute, 50% 7px null null);
    transform: translateY(-50%);
  }
}
</style>
